import React, { useEffect, useState } from "react";
import Appbar from "./Components/appbar";
import Menu from "./Components/Menu";
import Footer from "./Components/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faIndianRupeeSign, faSearch } from "@fortawesome/free-solid-svg-icons";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import Modal from "react-modal";
import "../style/MaintenanceRecord.css";
import { faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import Bus01 from "../images/bus1.jpg";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { Link, useLocation } from "react-router-dom";
import StatusTypeModel from "./Components/StatusSubModal";

const convert = (str) => {
  var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join("-");
};

const FormatDate = (inp) => {
  let dateformat = inp.split("T")[0];
  const date = moment(dateformat, "YYYY-MM-DD");
  return date.format("DD-MMM-YYYY");
};

export default function MaintenanceRecord() {
  const location = useLocation();
  const passedState = location.state;

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);
  const [MaintenanceList, SetMaintenanceList] = useState([]);
  const [selectedMaintenance, setSelectedMaintenance] = useState(null);
  const [BusList, SetBusList] = useState([]);
  const [BusStatus, SetBusStatus] = useState([]);
  const [PaymentMode, SetPaymentMode] = useState([]);
  const username = sessionStorage.getItem("username");
  const rights = sessionStorage.getItem("rights");

  const [searchQuery, setSearchQuery] = useState("");
  const [isDateInput, setIsDateInput] = useState([]);
  const today = new Date().toISOString().split("T")[0];

  const filteredMaintenance = searchQuery
    ? MaintenanceList.filter((item) =>
        item.Register_Number.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : MaintenanceList;

  const InitState = {
    busName: null,
    modelName: null,
    regNo: null,
    Date: null,
    serviceProvider: null,
    busStatus: null,
    dateofServiceGiven: null,
    dateofServiceReturn: null,
    reason: null,
    nextServiceDate: null,
    totalAmount: null,
    modeofPayment: null,
    user: username,
  };

  const [formData, setFormData] = useState(InitState);

  const [subModalIsOpen, setSubModalIsOpen] = useState(false);
  const [statusType, setStatusType] = useState(null);
  const [statusTypeSub, setStatusTypeSub] = useState({
    Status: null,
    Status_Ref: null,
  });

  const handleSubModalOpen = () => setSubModalIsOpen(true);
  const handleSubModalClose = () => setSubModalIsOpen(false);

  const handleStatusOnChange = async (e) => {
    let { name, value } = e.target;
    setStatusTypeSub({ ...statusTypeSub, [name]: value.toUpperCase() });
  };

  function selectStatusType(statusType) {
    switch (statusType) {
      case "Bus Status":
        return "Bus_Status";
        break;
      case "Mode Of Payment":
        return "Mode_of_Payment";
        break;

      default:
        break;
    }
  }

  const handleStatusTypeSubjectSubmit = async (event) => {
    event.preventDefault();
    const status = statusType ? selectStatusType(statusType) : "";
    console.log(status, statusType);
    try {
      await axios
        .post(
          `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/AddStatusTypeSub/${status}`,
          statusTypeSub,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            SuccessMSG(res.data.message);
            setStatusTypeSub({ Status: null, Status_Ref: null });
            if (statusType === "Bus Status") fetchBusStatus();
            if (statusType === "Mode Of Payment") fetchModeOfPayment();
            setStatusType(null);
            handleSubModalClose();
          }
          if (res.status === 201) {
            WarningMSG(res.data.message);
          }
        })
        .catch((err) => {
          if (err.response && err.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
      event.target.reset();
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  const fetchBusList = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/bus/FetchBusList`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      //console.log("Fetched data:", response.data);// Log the fetched data
      SetBusList(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };
  const fetchBusStatus = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/FetchStatusTypeSubByStatusName/Bus_Status`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      //console.log("Fetched data:", response.data);// Log the fetched data
      SetBusStatus(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };
  const fetchModeOfPayment = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/statusTypeSub/FetchStatusTypeSubByStatusName/Mode_Of_Payment`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      //console.log("Fetched data:", response.data);// Log the fetched data
      SetPaymentMode(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  const fetchMaintenanceList = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/maintenance/FetchMaintenanceRecord`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
          },
        },
        { withCredentials: true }
      );
      //console.log("Fetched data liost:", response.data);// Log the fetched data
      SetMaintenanceList(response.data);
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  useEffect(() => {
    fetchMaintenanceList();
    fetchBusList();
    fetchBusStatus();
    fetchModeOfPayment();
    const isText = Array(3).fill(false);
    setIsDateInput(isText);
  }, []);

  const SuccessMSG = (msg) => {
    //console.log(msg)
    toast.success(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };

  const WarningMSG = (msg) => {
    //console.log(msg)
    toast.warning(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const FailedMSG = (msg) => {
    //console.log(msg)
    toast.error(msg, {
      position: "top-center",
      autoClose: 2000, // Auto-dismiss after 2 seconds
      hideProgressBar: true, // Optional: Hide progress bar
      closeOnClick: true, // Optional: Allow closing on click
      pauseOnHover: false, // Optional: Pause on hover
      draggable: false, // Optional: Disable dragging
    });
  };
  const handleEdit = (Maintenance) => {
    const InitStateEdit = {
      maintenanceId: Maintenance.Maintenance_Id,
      busName: Maintenance.Bus_Name,
      modelName: Maintenance.Model_Name,
      regNo: Maintenance.Register_Number,
      Date:
        Maintenance.Maintenance_Date == null
          ? null
          : convert(Maintenance.Maintenance_Date.toString()),
      serviceProvider: Maintenance.Service_Provider,
      busStatus: Maintenance.Bus_Status,
      dateofServiceGiven:
        Maintenance.Date_of_Service_Given == null
          ? null
          : convert(Maintenance.Date_of_Service_Given.toString()),
      dateofServiceReturn:
        Maintenance.Date_of_Service_Return == null
          ? null
          : convert(Maintenance.Date_of_Service_Return.toString()),
      reason: Maintenance.Reason,
      nextServiceDate:
        Maintenance.Next_Service_Date == null
          ? null
          : convert(Maintenance.Next_Service_Date.toString()),
      totalAmount: Maintenance.Total_Amount,
      modeofPayment: Maintenance.Payment_Mode,
      user: username,
    };
    setSelectedMaintenance(InitStateEdit);
    //console.log(InitStateEdit)
    setModalIsOpen(true);
  };

  const handleModalClose = () => {
    const confirmClose = window.confirm("Are you sure you want to close?");
    if (confirmClose) {
      setModalIsOpen(false);
      setFormData(InitState);
      setSelectedMaintenance(null);
    }
  };

  const handleFocus = (index) => {
    const isText = [...isDateInput];
    isText[index] = true;
    setIsDateInput(isText);
  };

  const handleFocus1 = (index) => {
    const isText = [...isDateInput];
    isText[index] = false;
    setIsDateInput(isText);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const pattern = /[^a-zA-Z ]/g;
    if (name === "serviceProvider" || name === "reason") {
      let result = pattern.test(value);
      if (result) {
        setFormData({
          ...formData,
          [name]: value.replace(pattern, ""),
        });
      } else {
        setFormData({
          ...formData,
          [name]: value,
        });
      }
    } else if (name === "totalAmount") {
      setFormData({
        ...formData,
        [name]: value.replace(/[^0-9]/g, ""),
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const handleChangeDate = (e, index) => {
    const { name, value } = e.target;
    let date = new Date(e.target.value);
    //console.log((convert(date)))
    if (!isNaN(date)) {
      setFormData({
        ...formData,
        [name]: convert(date),
      });
    }
  };
  const handleUpdateDate = (e, index) => {
    const { name, value } = e.target;
    let date = new Date(e.target.value);
    //console.log((convert(date)))
    if (!isNaN(date)) {
      setSelectedMaintenance({
        ...selectedMaintenance,
        [name]: convert(date),
      });
      // Switch back to text to display the formatted date
    }
  };

  const handleUpdate = (e) => {
    const { name, value } = e.target;
    const pattern = /[^a-zA-Z ]/g;
    if (name === "serviceProvider" || name === "reason") {
      let result = pattern.test(value);
      if (result) {
        setSelectedMaintenance({
          ...selectedMaintenance,
          [name]: value.replace(pattern, ""),
        });
      } else {
        setSelectedMaintenance({
          ...selectedMaintenance,
          [name]: value,
        });
      }
    } else if (name === "totalAmount") {
      setSelectedMaintenance({
        ...selectedMaintenance,
        [name]: value.replace(/[^0-9]/g, ""),
      });
    } else {
      setSelectedMaintenance({
        ...selectedMaintenance,
        [name]: value,
      });
    }
  };

  //Create Operation 

  const handleMaintenanceSelectChange = (e) => {
    console.log(e);
    const selectedIndex = BusList.findIndex((item) => item.Bus_Name === e);
    const BusName = BusList[selectedIndex].Bus_Name;
    const BusModelName = BusList[selectedIndex].Model_Name;
    const BusRegNo = BusList[selectedIndex].Register_Number;
    const BusStatus = BusList[selectedIndex].Bus_Status;
    setFormData({
      ...formData,
      busName: BusName,
      regNo: BusRegNo,
      modelName: BusModelName,
      busStatus: BusStatus,
    });
  };


  //Update Operation 

  const handleMaintenanceSelectChange1 = (e) => {
    console.error(e);
    const selectedIndex = BusList.findIndex((item) => item.Bus_Name === e);
    const BusName = BusList[selectedIndex].Bus_Name;
    const BusModelName = BusList[selectedIndex].Model_Name;
    const BusRegNo = BusList[selectedIndex].Register_Number;
    const BusStatus = BusList[selectedIndex].Bus_Status;
    setSelectedMaintenance({
      ...selectedMaintenance,
      busName: BusName,
      regNo: BusRegNo,
      modelName: BusModelName,
      busStatus: BusStatus,
    });
  };

  const UpdateForm = async (e) => {
    e.preventDefault();

    try {
      await axios
        .put(
          `${process.env.REACT_APP_API_BASE_URL}/maintenance/UpdateMaintenanceRecord/${selectedMaintenance.maintenanceId}`,
          selectedMaintenance,
          {
            headers: {
              authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          SuccessMSG(res.data.message);
          setSelectedMaintenance([]);
          fetchMaintenanceList();
        })
        .catch((error) => {
          console.error(error.message);
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    } finally {
      setSelectedMaintenance([]);
      //console.log(formData);
      closeModal();
    }
  };
  const handleDelete = async (Maintenance) => {
    try {
      const confirm = window.confirm("Are you sure you want to delete this?");
      if (!confirm) return;
      await axios
        .delete(
          `${process.env.REACT_APP_API_BASE_URL}/maintenance/DeleteMaintenanceRecord/${Maintenance.Maintenance_Id}`,
          {
            headers: {
              authorization: `Bearer ${sessionStorage.getItem("access_token")}`,
            },
          }
        )
        .then((res) => {
          SuccessMSG(res.data.message);
          fetchMaintenanceList();
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    console.log(formData);
    try {
      await axios
        .post(
          `${process.env.REACT_APP_API_BASE_URL}/maintenance/AddMaintenanceRecord`,
          formData
        )
        .then((res) => {
          SuccessMSG(res.data.message);
          fetchMaintenanceList();
        })
        .catch((error) => {
          if (error.response && error.response.status !== 200)
            FailedMSG("Something went Wrong");
        });
      fetchMaintenanceList();
    } catch (error) {
      if (error.response && error.response.status !== 200)
        FailedMSG("Something went Wrong");
    } finally {
      setFormData(InitState);
      closeModal();
    }
    //console.log(formData);
  };

  return (
    <>
      <ToastContainer />
      <Appbar username={username} rights={rights}></Appbar>
      <div className="MaintenanceRecord">
        <Menu username={username} rights={rights}></Menu>
        <div className="MaintenanceRecordPage">
          <p className="MaintenanceRecordHeadLabel">Maintenance Record</p>
          <div className="MaintenanceRecordHeaders">
            <div className="MaintenanceRecordRegSearch">
              <input
                className="MaintenanceRecordRegInput"
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Reg No"
              ></input>
              <button className="MaintenanceRecordSearchBtn">
                <FontAwesomeIcon
                  className="MaintenanceRecordRegSearchIcon"
                  title="Search"
                  icon={faSearch}
                ></FontAwesomeIcon>
              </button>
            </div>
            <button
              className="NewMaintenanceRecordBtn"
              title="Add New"
              onClick={openModal}
            >
              Add New{" "}
              <FontAwesomeIcon
                className="MaintenanceRecordAddNewIcon"
                icon={faPlus}
              ></FontAwesomeIcon>
            </button>
          </div>
          <Modal
            isOpen={modalIsOpen}
            shouldCloseOnOverlayClick={false}
            onRequestClose={handleModalClose}
            contentLabel="MaintenanceRecord Form"
            center
            style={{
              overlay: {
                background: "rgba(0,0,0,0.6)",
                position: "fixed",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
              },
              content: {
                background: "linear-gradient(168deg, #c1e0ff 0%, #efdeff 100%)",
                position: "absolute",
                top: "40px",
                left: "25%",
                right: "25%",
                bottom: "40px",
                height: "auto",
                width: "50%",
                overflow: "scroll",
              },
            }}
          >
            <FontAwesomeIcon
              className="MaintenanceRecordFormCloseBtn"
              onClick={handleModalClose}
              title="Close"
              icon={faClose}
            ></FontAwesomeIcon>
            <p className="MaintenanceRecordFormHeadLabel">
              {selectedMaintenance?.maintenanceId
                ? "Edit Maintenance Record"
                : "Add Maintenance Record"}
            </p>
            <form
              className="MaintenanceRecordForm"
              onSubmit={
                selectedMaintenance?.maintenanceId ? UpdateForm : handleSubmit
              }
            >
              <div className="MaintenanceRecordFormFlex">
                <div className="MaintenanceRecordform1">
                  <div className="MaintenanceRecordformFeilds">
                    <label className="MaintenanceRecordFormLabels">
                      Bus Name <span>*</span>
                    </label>
                    <select
                      required
                      className="MaintenanceRecordFormSelects"
                      value={
                        selectedMaintenance
                          ? selectedMaintenance.busName
                          : formData.busName
                      }
                      onChange={(e) =>
                        selectedMaintenance
                          ? handleMaintenanceSelectChange1(e.target.value)
                          : handleMaintenanceSelectChange(e.target.value)
                      }
                      name="busName"
                    >
                      <option value={""}> Select </option>
                      {BusList.map((item, index) => (
                        <option key={index} value={item.Bus_Name}>
                          {item.Bus_Name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="MaintenanceRecordformFeilds">
                    <label className="MaintenanceRecordFormLabels">
                      Register Number <span>*</span>
                    </label>
                    <input
                      required
                      readOnly
                      placeholder="Register Number"
                      value={selectedMaintenance?.regNo || formData.regNo}
                      className="MaintenanceRecordFormInputs"
                      type="text"
                      name="regNo"
                    ></input>
                  </div>
                </div>
                <div className="MaintenanceRecordform1">
                  <div className="MaintenanceRecordformFeilds">
                    <label className="MaintenanceRecordFormLabels">
                      Model Name <span>*</span>
                    </label>
                    <input
                      required
                      placeholder="Model Name"
                      value={
                        selectedMaintenance?.modelName || formData.modelName
                      }
                      className="MaintenanceRecordFormInputs"
                      type="text"
                      name="modelName"
                      readOnly
                    ></input>
                  </div>
                  <div className="MaintenanceRecordformFeilds">
                    <label className="MaintenanceRecordFormLabels">
                      Bus Status <span>* </span>
                      <Link
                        style={{ fontSize: "12px" }}
                        state={{
                          username: username,
                          rights: rights,
                        }}
                        to={""}
                        onClick={() => {
                          setStatusType("Bus Status");
                          handleSubModalOpen();
                        }}
                      >
                        (Add New Status)
                      </Link>
                    </label>
                    <select
                      required
                      className="MaintenanceRecordFormSelects"
                      value={
                        selectedMaintenance
                          ? selectedMaintenance.busStatus
                          : formData.busStatus
                      }
                      onChange={
                        selectedMaintenance ? handleUpdate : handleChange
                      }
                      name="busStatus"
                    >
                      <option value={""}> Select </option>
                      {BusStatus.map((item, index) => (
                        <option key={index} value={item.Status_Ref}>
                          {item.Status_Ref}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="MaintenanceRecordform1">
                  <div className="MaintenanceRecordformFeilds">
                    <label className="MaintenanceRecordFormLabels">Date</label>
                    <input
                      placeholder="01-Jan-1900"
                      className="MaintenanceRecordFormInputs"
                      type={isDateInput[0] ? "date" : "text"}
                      onFocus={() => handleFocus(0)}
                      onBlur={() => handleFocus1(0)}
                      readOnly={!isDateInput[0]}
                      max={today}
                      value={
                        selectedMaintenance
                          ? selectedMaintenance.Date
                            ? FormatDate(selectedMaintenance.Date)
                            : selectedMaintenance.Date
                          : formData.Date
                          ? FormatDate(formData.Date)
                          : formData.Date
                      }
                      onChange={(e) =>
                        selectedMaintenance
                          ? handleUpdateDate(e, 0)
                          : handleChangeDate(e, 0)
                      }
                      name="Date"
                    ></input>
                  </div>
                  <div className="MaintenanceRecordformFeilds">
                    <label className="MaintenanceRecordFormLabels">
                      Service Provider
                    </label>
                    <input
                      placeholder="Service Provider"
                      className="MaintenanceRecordFormInputs"
                      value={
                        selectedMaintenance?.serviceProvider ||
                        formData.serviceProvider
                      }
                      onChange={
                        selectedMaintenance ? handleUpdate : handleChange
                      }
                      type="text"
                      name="serviceProvider"
                    ></input>
                  </div>
                </div>
                <div className="MaintenanceRecordform1">
                  <div className="MaintenanceRecordformFeilds">
                    <label className="MaintenanceRecordFormLabels">
                      Date of Service Given{" "}
                    </label>
                    <input
                      placeholder="01-Jan-1900"
                      className="MaintenanceRecordFormInputs"
                      type={isDateInput[1] ? "date" : "text"}
                      onFocus={() => handleFocus(1)}
                      onBlur={() => handleFocus1(1)}
                      readOnly={!isDateInput[1]}
                      max={today}
                      value={
                        selectedMaintenance
                          ? selectedMaintenance.dateofServiceGiven
                            ? FormatDate(selectedMaintenance.dateofServiceGiven)
                            : selectedMaintenance.dateofServiceGiven
                          : formData.dateofServiceGiven
                          ? FormatDate(formData.dateofServiceGiven)
                          : formData.dateofServiceGiven
                      }
                      onChange={(e) =>
                        selectedMaintenance
                          ? handleUpdateDate(e, 1)
                          : handleChangeDate(e, 1)
                      }
                      name="dateofServiceGiven"
                    ></input>
                  </div>
                  <div className="MaintenanceRecordformFeilds">
                    <label className="MaintenanceRecordFormLabels">
                      Date of Service Return{" "}
                    </label>
                    <input
                      placeholder="01-Jan-1900"
                      className="MaintenanceRecordFormInputs"
                      type={isDateInput[2] ? "date" : "text"}
                      onFocus={() => handleFocus(2)}
                      onBlur={() => handleFocus1(2)}
                      readOnly={!isDateInput[2]}
                      max={today}
                      value={
                        selectedMaintenance
                          ? selectedMaintenance.dateofServiceReturn
                            ? FormatDate(
                                selectedMaintenance.dateofServiceReturn
                              )
                            : selectedMaintenance.dateofServiceReturn
                          : formData.dateofServiceReturn
                          ? FormatDate(formData.dateofServiceReturn)
                          : formData.dateofServiceReturn
                      }
                      onChange={(e) =>
                        selectedMaintenance
                          ? handleUpdateDate(e, 2)
                          : handleChangeDate(e, 2)
                      }
                      name="dateofServiceReturn"
                    ></input>
                  </div>
                </div>
                <div className="MaintenanceRecordform1">
                  <div className="MaintenanceRecordformFeilds1">
                    <label className="MaintenanceRecordFormLabels">
                      Purpose
                    </label>
                    <textarea
                      placeholder="Purpose"
                      className="MaintenanceRecordFormInputs1"
                      type="text"
                      value={selectedMaintenance?.reason || formData.reason}
                      onChange={
                        selectedMaintenance ? handleUpdate : handleChange
                      }
                      name="reason"
                    ></textarea>
                  </div>
                </div>
                <div className="MaintenanceRecordform1">
                  <div className="MaintenanceRecordformFeilds">
                    <label className="MaintenanceRecordFormLabels">
                      Next Service Date
                    </label>
                    <input
                      placeholder="01-Jan-1900"
                      className="MaintenanceRecordFormInputs"
                      type={isDateInput[3] ? "date" : "text"}
                      onFocus={() => handleFocus(3)}
                      onBlur={() => handleFocus1(3)}
                      readOnly={!isDateInput[3]}
                      min={today}
                      value={
                        selectedMaintenance
                          ? selectedMaintenance.nextServiceDate
                            ? FormatDate(selectedMaintenance.nextServiceDate)
                            : selectedMaintenance.nextServiceDate
                          : formData.nextServiceDate
                          ? FormatDate(formData.nextServiceDate)
                          : formData.nextServiceDate
                      }
                      onChange={(e) =>
                        selectedMaintenance
                          ? handleUpdateDate(e, 3)
                          : handleChangeDate(e, 3)
                      }
                      name="nextServiceDate"
                    ></input>
                  </div>
                </div>
                <div className="MaintenanceRecordform1">
                  <div className="MaintenanceRecordformFeilds">
                    <label className="MaintenanceRecordFormLabels">
                      Total Amount (₹)
                    </label>
                    <input
                      placeholder="₹ Total Amount"
                      className="MaintenanceRecordFormInputs"
                      value={
                        selectedMaintenance?.totalAmount || formData.totalAmount
                      }
                      onChange={
                        selectedMaintenance ? handleUpdate : handleChange
                      }
                      type="text"
                      name="totalAmount"
                    ></input>
                  </div>
                  <div className="MaintenanceRecordformFeilds">
                    <label className="MaintenanceRecordFormLabels">
                      Mode of Payment{" "}
                      <Link
                        style={{ fontSize: "12px" }}
                        state={{
                          username: username,
                          rights: rights,
                        }}
                        to={""}
                        onClick={() => {
                          setStatusType("Mode Of Payment");
                          handleSubModalOpen();
                        }}
                      >
                        {" "}
                        (Add Payment Mode)
                      </Link>{" "}
                    </label>
                    <select
                      className="MaintenanceRecordFormSelects"
                      value={
                        selectedMaintenance
                          ? selectedMaintenance.modeofPayment
                          : formData.modeofPayment
                      }
                      onChange={
                        selectedMaintenance ? handleUpdate : handleChange
                      }
                      name="modeofPayment"
                    >
                      <option value={""}> Select </option>
                      {PaymentMode.map((item, index) => (
                        <option key={index} value={item.Status_Ref}>
                          {item.Status_Ref}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
              <div className="MaintenanceRecordFormFooter">
                <div className="MaintenanceRecordFormFooterBtns">
                  <button
                    className="MaintenanceRecordFormSubmitBtn"
                    title="Submit"
                    type="submit"
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </form>
          </Modal>
          <StatusTypeModel
            isOpen={subModalIsOpen}
            onClose={handleSubModalClose}
            statusTypeSub={statusTypeSub}
            handleChange={handleStatusOnChange}
            handleSubmit={handleStatusTypeSubjectSubmit}
            statusType={statusType}
          />
          <div className="MaintenanceRecordLists">
            {filteredMaintenance.length < 1 ? (
              <p className="" style={{ textAlign: "center", width: "100%" }}>
                There is No Maintenances Recorded
              </p>
            ) : (
              filteredMaintenance.map((items, index) => {
                return (
                  <div className="MaintenanceRecordIndex">
                    <img
                      src={Bus01}
                      alt=""
                      className="MaintenanceRecordIndexImg"
                    ></img>
                    <div className="MaintenanceRecordIndexDetails px-5">
                      <div className="MaintenanceRecordIndex0">
                        <div className="MaintenanceRecordGrp">
                          <p className="MaintenanceRecordGrpValues">
                            {items.Maintenance_Id}
                          </p>
                        </div>
                        <div className="MaintenanceRecordGrp">
                          <p className="MaintenanceRecordGrpValues">
                            {items.Bus_Name}
                          </p>
                        </div>
                        <div className="MaintenanceRecordGrp">
                          <p className="MaintenanceRecordGrpValues">
                            {items.Register_Number}
                          </p>
                        </div>
                      </div>
                      <div className="MaintenanceRecordIndex1">
                        <div className="MaintenanceRecordIndexGrp">
                          {items.Bus_Status === "INACTIVE" ? (
                            <FontAwesomeIcon
                              className="MaintenanceRecordIndexGrpStatusIcon"
                              style={{ color: "red", opacity: "0.5" }}
                              icon={faCircleXmark}
                            ></FontAwesomeIcon>
                          ) : (
                            <FontAwesomeIcon
                              className="MaintenanceRecordIndexGrpStatusIcon"
                              style={{ color: "green", opacity: "0.5" }}
                              icon={faSquareCheck}
                            ></FontAwesomeIcon>
                          )}
                          <p className="MaintenanceRecordGrpValues1">
                            {items.Bus_Status}
                          </p>
                        </div>
                        <div className="MaintenanceRecordIndexGrp">
                          <FontAwesomeIcon
                            className="MaintenanceRecordIndexGrpPassengerIcon"
                            style={{ color: "#4776E6" }}
                            icon={faIndianRupeeSign}
                          ></FontAwesomeIcon>
                          <p className="MaintenanceRecordGrpValues1">
                            {items.Total_Amount}
                          </p>
                        </div>
                        <div className="MaintenanceRecordGrpBtn">
                          <FontAwesomeIcon
                            className="MaintenanceRecordEditIcon"
                            onClick={() => handleEdit(items)}
                            title="Edit"
                            icon={faEdit}
                          ></FontAwesomeIcon>
                          <FontAwesomeIcon
                            className="MaintenanceRecordDeleteIcon"
                            onClick={() => handleDelete(items)}
                            title="Delete"
                            icon={faTrash}
                          ></FontAwesomeIcon>
                        </div>
                      </div>
                      <div className="MaintenanceRecordIndex2">
                        <div className="MaintenanceRecordLastGrp">
                          <p className="MaintenanceRecordGrpValues1">
                            {items.Maintenance_Date == null
                              ? null
                              : FormatDate(convert(items.Maintenance_Date))}
                          </p>
                          <p className="MaintenanceRecordGrpValues2">
                            {items.Reason}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
}
